import { InfoCircleOutlined } from '@ant-design/icons'
import { IconCloseCircle } from '../../../assets/icons'
import './index.scss'

export default function BaseInput({ className = '', inputClassName = '', error, buttonRight, showClear = false, onClear, ...props }) {
  const shouldShowClear = showClear && !props.disabled && typeof onClear === 'function'

  return (
    <div className={`BaseInput ${error ? 'BaseInput--has-error' : ''} ${className}`.trim()}>
      <div className="BaseInput_wrapper">
        <div className="BaseInput_inputWrapper">
          <input
            className={`BaseInput_input ${error ? 'BaseInput_input--error' : ''} ${shouldShowClear ? 'BaseInput_input--has-clear' : ''} ${inputClassName}`.trim()}
            {...props}
          />
          {shouldShowClear && (
            <button
              type="button"
              className="BaseInput_clearButton"
              aria-label="Xóa nội dung"
              onMouseDown={(event) => event.preventDefault()}
              onClick={onClear}>
              <IconCloseCircle />
            </button>
          )}
        </div>
        {buttonRight && <div className="BaseInput_buttonRight">{buttonRight}</div>}
      </div>
      {error && (
        <span className="BaseInput_error">
          <InfoCircleOutlined style={{ fontSize: '13px', marginRight: '4px' }} />
          {error}
        </span>
      )}
    </div>
  )
}
